// ----------------------------------------------------------------------------
// Template: Blog
// ----------------------------------------------------------------------------
//
// ----------------------------------------------------------------------------

// -------------------------------------
// Dependencies
// -------------------------------------

// Scripts
import 'sections/header/header';
import 'sections/blog-filtering/blog-filtering';
import 'snippets/pagination/pagination';
import 'sections/page-header/page-header';
import 'sections/blog-posts/blog-posts';
import 'sections/footer/footer';
import 'sections/country-modal/country-modal';

// Styles
import './_blog.scss';
